'use client';

import type { CSSProperties, ReactNode } from 'react';
import { useMainContentScrollStore } from '@/shared/store';
import { ScrollArea } from '@ncai-axe/react-ui-v3';
import styles from './styles.module.scss';

interface MainContentScrollProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function MainContentScroll({
  children,
  className,
  style,
}: MainContentScrollProps) {
  const showHorizontalScrollbar = useMainContentScrollStore(
    (s) => s.showHorizontalScrollbar,
  );

  return (
    // data-owns-h-scroll: 이 영역이 가로 스크롤을 소유한다는 마커(에디터/배너 리스트 등).
    // global.scss 의 `.appLayout:has(main[data-owns-h-scroll])` 가 셸의 1440px 하한을 해제해
    // 바깥(AppScrollArea) 가로 스크롤바와 이중이 되는 것을 막는다.
    <main
      className={className}
      style={style}
      data-owns-h-scroll={showHorizontalScrollbar ? '' : undefined}
    >
      <ScrollArea
        type="hover"
        className={styles.scrollArea}
        aria-label="메인 콘텐츠 영역"
        showHorizontalScrollbar={showHorizontalScrollbar}
      >
        {children}
      </ScrollArea>
    </main>
  );
}
